import React, { useState } from "react";

// reactstrap components
import {
    Button,
    Modal,
    ModalBody,
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";


//function Register() {
const Register = (props) => {

    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);

    const [Username, setUserName] = useState("");
    const [Password, setPassword] = useState("");
    const [Password2, setPassword2] = useState("");
    const [Email, setEmail] = useState("");
    const [LineTrangskin, setLineTrangskin] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [CID, setCID] = useState("");
    const [phone, setPhone] = useState("");
    const [bDay, setbDay] = useState("");
    const [bMonth, setbMonth] = useState("");
    const [bYear, setbYear] = useState("");
    const [icon, setIcon] = useState("far fa-question-circle" );



    const liff = window.liff;
    liff.init({
        liffId: '1654063801-YmzNbmj5'
    })
    .then(() => {

        if (liff.isLoggedIn()) {

            liff.getProfile().then(function (profile) {
                setLineTrangskin(profile.userId);
            }).catch(function (error) {
                window.alert('Error getting profile: ' + error);
            });

        }
    })
    .catch((err) => {

    });
    
    

    React.useEffect(() => {
        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };

    });

    const handleSubmit = (evt) => {
        evt.preventDefault();
        var cntErr = 0;
        var birthdate = moment([bYear, bMonth-1, bDay]);

        var errMsg = '';

        if (birthdate.isValid()) {

        }
        else {
            cntErr += 1;
            errMsg = 'กรุณาระบุวันเดือนปีเกิดให้ถูกต้อง';
        }

        
        if (phone == null || phone == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุหมายเลขโทรศัพท์';
        }


        if (CID == null || CID == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุเลขที่บัตรประจำตัวประชาชน';
        }
        else if (CID.length < 13) {
            cntErr += 1;
            errMsg = 'เลขที่บัตรประจำตัวประชาชนไม่ครบ 13 หลัก';
        }

        if (LastName == null || LastName == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุนามสกุล';
        }

        if (FirstName == null || FirstName == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุชื่อ';
        }




        if (Password == null || Password == '' || Password2 == null || Password2 == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุ Password ให้ถูกต้อง';
        }
        else if (Password != Password2) {
            cntErr += 1;
            errMsg = 'กรุณายืนยันรหัสผ่านให้ตรงกัน';
        }

        if (Email == null || Email == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุ Email';
        }

        if (Username == null || Username == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุ Username';
        }

     
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModal2(true);
        }
      
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var birthdate = moment([bYear, bMonth - 1, bDay]);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
            body: JSON.stringify({
                "username": Username,
                "password": Password,
                "email": Email,
                "lineTrangskin": LineTrangskin,
                "firstName": FirstName,
                "lastName": LastName,
                "idCard": CID,
                "phone": phone,
                "birthDate": birthdate.format('YYYY-MM-DD')
            })
        };

        fetch('/api/v1/identity/web-register', requestOptions)
            .then(response => response.json())
            .then(
                (result) => { 
         

                        if (liff.isInClient()) {

                            liff.sendMessages([{
                                'type': 'text',
                                'text': '#registered'
                            }]).then(function () {
                                //window.alert('Message sent');
                                liff.closeWindow();
                            }).catch(function (error) {
                                window.alert('Error sending message: ' + error);
                            });

                        } else {
                            authenticationService.login(Username, Password)
                                .then(
                                    user => {
                                        const { from } = props.location.state || { from: { pathname: "/profile" } };
                                        props.history.push(from);
                                    },
                                    error => {

                                        if (result.errors !== "undefined") {
                                            try {

                                                setModal2(false);
                                                setIcon("far fa-question-circle");
                                                setErrMsg(result.errors[0]);
                                                setModalError(true);

                                            }
                                            catch (e) { console.log(e) }
                                        }
 
                                    }
                                );
                        }

                },
                (error) => {
                    alert(error);
                }
            )
    }

    const handleCID = (val) => {  
        setCID(val)
        let e = val;

        if (e.length === 13) {
            let sum = 0; 
            for (let i = 0; i < 12; i++) {
                sum += parseFloat(e.charAt(i)) * (13 - i);
            }

            if ((11 - sum % 11) % 10 !== parseFloat(e.charAt(12))) {

                setCID('')
                setErrMsg('เลขบัตรประชาชนของคุณไม่ถูกต้องตามหลักทะเบียนราษฎร์');
                setModalError(true);
                //$('#inputid').addClass('has-error');
                //return false;

            } else {

                //$('#inputid').removeClass('has-error');
                //$('#inputid').addClass('has-success');
                //return true;

            }
        }
    }

    var moment = require('moment');
    require('moment/locale/th');

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
            <div className="main">
                  {/*
                   <div className="section">
                      <Container>
                          <Row>
                              <Col md="2">
                              </Col>
                              <Col md="8">
                                  <div className="hero-images-container" style={{ marginTop: '-20vh', maxWidth:'680px'}}>
                                      <img
                                          alt="..."
                                          src={require("assets/img/ts_logo_xl.png")}
                                      ></img>
                                  </div>
                              </Col>
                              <Col md="2">
                              </Col>
                          </Row>
                      </Container>
                  </div>
                   */}
            </div>
        
            <div className="section section-contact-us text-left" style={{ padding: '0' }}>
                <Container>
                      <h2 className="title text-center">ลงทะเบียนข้อมูลเพื่อเข้ารับบริการ</h2>
                      <p className="description"></p>
                      <Row>
                          <Col xs="12" sm="6" lg="3">
                              <TSText placeholder="Username" onChange={e => setUserName(e.target.value)} icon="fas fa-user-shield fa-2x" />
                          </Col>
                          <Col xs="12" sm="6" lg="3">
                              <TSText placeholder="Email" onChange={e => setEmail(e.target.value)} icon="far fa-envelope fa-2x" />
                          </Col>
                          <Col xs="12" sm="6" lg="3">
                              <TSText type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} icon="fas fa-key fa-2x" />
                          </Col>
                          <Col xs="12" sm="6" lg="3">
                              <TSText type="password" placeholder="ยืนยัน Password" onChange={e => setPassword2(e.target.value)} icon="fas fa-key fa-2x" />
                          </Col>
                      </Row>

                      <Row>
                          {/*
                          <Col md="2">
                              <TSSelect placeholder="คำนำหน้า" url="/api/title" onChange={e => setTitle(e.target.value)} />
                          </Col>
                         

                          <Col md="12">
                              <TSText placeholder="Line Token" value={LineTrangskin}  onChange={e => setLineTrangskin(e.target.value)} />
                          </Col>
                           */}
                          <Col md="3">
                              <TSText placeholder="ชื่อ"  onChange={e => setFirstName(e.target.value)} icon="fas fa-user-edit fa-2x"/>
                          </Col>
                          <Col md="3">
                              <TSText placeholder="สกุล" onChange={e => setLastName(e.target.value)} icon="fas fa-user-edit fa-2x"/>
                          </Col>
                          <Col md="3">
                              <TSText type="tel" placeholder="เลขที่บัตรประจำตัวประชาชน" value={CID} maxLength="13" onChange={e => handleCID(e.target.value)/*setCID(e.target.value)*/} icon="far fa-id-card fa-2x" />
                          </Col>
                          <Col md="3">
                              <TSText maxLength="10" type="tel" placeholder="หมายเลขโทรศัพท์" value={phone} onChange={e => setPhone(e.target.value)} icon="fas fa-mobile-alt fa-2x"/>
                          </Col>
                      </Row>                      
                      <Row>
                          <Col lg="12" className="text-left">
                              <span>วัน เดือน ปี เกิด</span>
                          </Col>
                          <Col xs="3" lg="4">
                              <TSSelect placeholder="วัน" isDefault={true} fixData="day" onChange={e => setbDay(e)} />

                          </Col>
                          <Col xs="5" lg="4">
                              <TSSelect placeholder="เดือน" isDefault={true} fixData="month" onChange={e => setbMonth(e)} />
                          </Col>
                          <Col xs="4" lg="4">
                              <TSSelect placeholder="ปี" isDefault={true} fixData="year" onChange={e => setbYear(e)} />
                          </Col>

                      </Row>

                      <Row>
                          <Col className="text-center ml-auto mr-auto" lg="6" md="8">
                            <Button
                                  block
                                  className="btn-round"
                                  color="info"
                                  href="#pablo"
                                  size="lg"
                                  style={{ fontSize: '1.2em' }}
                                  onClick={handleSubmit}
                              >
                                  ลงทะเบียน
                             </Button>

                              {/* Confirm */}
                              <Modal
                                  modalClassName="modal-mini modal-info"
                                  toggle={() => setModal2(false)}
                                  isOpen={modal2}
                              >
                                  <div className="modal-header justify-content-center">
                                      <div className="modal-profile">
                                          <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                      </div>
                                  </div>
                                  <ModalBody>
                                      
                                      <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล":"กำลังตรวจสอบข้อมูล"}</p>
                                      <p>  </p>
                                  </ModalBody>
                                  <div className="modal-footer">
                                      <Button
                                          className="btn-neutral"
                                          color="link"
                                          type="button"
                                          onClick={() => setModal2(false)}
                                      >
                                          ยกเลิก
                                      </Button>

                                      <Button
                                          className="btn-neutral"
                                          color="link"
                                          type="button"
                                          onClick={handleConfirm}
                                          disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"} 
                                          //onClick={() => setModal2(false)}
                                      >
                                          ยืนยัน
                                      </Button>
                                  </div>
                              </Modal>


                              {/* Error */}
                              <Modal
                                  modalClassName="modal-mini modal-danger"
                                  toggle={() => setModalError(false)}
                                  isOpen={modalError}
                              >
                                  <div className="modal-header justify-content-center">
                                      <div className="modal-profile">
                                          <i className="fa fa-times" style={{ color: 'red', fontSize: '2em'}}></i>
                                      </div>
                                  </div>
                                  <ModalBody>
                                      <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                      <p> {errMsg} </p>
                                  </ModalBody>
                                  <div className="modal-footer justify-content-center">
                                      <Button
                                          className="btn-neutral"
                                          color="neutral"
                                          type="button"
                                          onClick={() => setModalError(false)}
                                      >
                                          ตกลง
                                      </Button>
                                  </div>
                              </Modal>
                            </Col>
                      </Row>

                      
                                
                  </Container>
            </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default Register;
